
export type SortDirectionParamParameter = typeof SortDirectionParamParameter[keyof typeof SortDirectionParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortDirectionParamParameter = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
